import { Link } from "react-router-dom";
import { Heart, Star } from "lucide-react";
import { useStore } from "@/context/StoreContext";
import { brl, img, effPrice, pixPrice } from "@/lib/api";

export const Stars = ({ value = 0, size = "h-3.5 w-3.5" }) => (
  <div className="flex gap-0.5" aria-label={`${value} de 5 estrelas`}>
    {[1, 2, 3, 4, 5].map((i) => <Star key={i} className={`${size} ${i <= Math.round(value) ? "fill-[#00C8FF] text-[#00C8FF]" : "text-[#3a3f4a]"}`} />)}
  </div>
);

export default function ProductCard({ p }) {
  const { favorites, toggleFav, settings } = useStore();
  const price = effPrice(p);
  const off = p.promo_price && p.price > p.promo_price ? Math.round((1 - p.promo_price / p.price) * 100) : 0;
  const inst = settings?.max_installments || 6;
  const fav = favorites.includes(p.id);
  return (
    <article className="group relative bg-[#171A1F] border border-[#282D37] hover:border-[#008CFF]/50 rounded-2xl overflow-hidden flex flex-col transition-[border-color,transform] duration-300 hover:-translate-y-1" data-testid={`product-card-${p.slug}`}>
      <Link to={`/produto/${p.slug}`} className="relative block aspect-square overflow-hidden bg-[#0B0D11]">
        <img src={img(p.images?.[0])} alt={p.name} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
        <div className="absolute top-3 left-3 flex flex-col gap-1.5">
          {off > 0 && <span className="chip bg-[#008CFF] text-white">-{off}%</span>}
          {p.customizable && <span className="chip bg-black/70 text-[#00C8FF] border border-[#00C8FF]/40">Personalizável</span>}
          {p.launch && <span className="chip bg-white text-black">Lançamento</span>}
        </div>
      </Link>
      <button onClick={() => toggleFav(p.id)} aria-label={fav ? "Remover dos favoritos" : "Favoritar"} className="absolute top-3 right-3 h-9 w-9 rounded-full bg-black/60 backdrop-blur grid place-items-center hover:bg-black" data-testid={`fav-btn-${p.slug}`}>
        <Heart className={`h-4 w-4 ${fav ? "fill-[#00C8FF] text-[#00C8FF]" : "text-white"}`} />
      </button>
      <div className="p-4 flex flex-col flex-1">
        <div className="flex items-center gap-2 mb-1.5"><Stars value={p.rating_avg} /><span className="text-[11px] text-[#A0A0A0]">({p.rating_count || 0})</span></div>
        <Link to={`/produto/${p.slug}`} className="font-display font-semibold text-[15px] leading-snug line-clamp-2 hover:text-[#00C8FF]">{p.name}</Link>
        <div className="mt-3">
          {off > 0 && <div className="text-xs text-[#A0A0A0] line-through">{brl(p.price)}</div>}
          <div className="text-xl font-bold font-display">{brl(price)}</div>
          <div className="text-xs text-[#A0A0A0]">ou {inst}x de {brl(price / inst)}</div>
          <div className="text-xs font-semibold text-[#00C8FF] mt-0.5">{brl(pixPrice(p, settings?.pix_discount_percent))} no Pix</div>
        </div>
        <Link to={`/produto/${p.slug}`} className="btn-primary mt-4 w-full py-2.5" data-testid={`buy-btn-${p.slug}`}>Comprar</Link>
      </div>
    </article>
  );
}
